export const publicStatusTenantSlugFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/public\/([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\/?$/i);
  return match?.[1]?.toLowerCase() ?? null;
};
